export default "__VITE_ASSET__1b219f6e__"